/**
 * Navigation Drawer 组件 JavaScript
 * 处理导航项目的点击、选中状态切换等交互功能
 */

document.addEventListener('DOMContentLoaded', function() {
  initNavigationDrawers();
});

function initNavigationDrawers() {
  const navigationDrawers = document.querySelectorAll('[data-component="navigation-drawer"]');
  
  navigationDrawers.forEach(drawer => {
    const navItems = drawer.querySelectorAll('.component-navigation-drawer__nav-item');
    
    navItems.forEach(item => {
      // 跳过禁用状态的项目
      if (item.hasAttribute('data-disabled')) {
        return;
      }
      
      // 点击事件处理
      item.addEventListener('click', function(e) {
        e.preventDefault();
        
        const url = this.getAttribute('data-url');
        const isSelected = this.hasAttribute('data-selected');
        
        // 如果有 URL，进行导航
        if (url && url !== '') {
          window.location.href = window.withSitePrefix ? window.withSitePrefix(url) : url;
          return;
        }
        
        // 处理选中状态切换
        handleSelectionChange(drawer, this);
        
        // 触发自定义事件
        const event = new CustomEvent('navigation-drawer:item-clicked', {
          detail: {
            item: this,
            label: this.querySelector('.component-navigation-drawer__label').textContent,
            url: url,
            isSelected: isSelected
          }
        });
        drawer.dispatchEvent(event);
      });
      
      // 键盘事件处理
      item.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
      
      // 设置可访问性属性
      item.setAttribute('tabindex', '0');
      item.setAttribute('role', 'button');
      
      const label = item.querySelector('.component-navigation-drawer__label');
      if (label) {
        item.setAttribute('aria-label', label.textContent);
      }
    });
  });
}

/**
 * 处理选中状态切换
 */
function handleSelectionChange(drawer, clickedItem) {
  const navItems = drawer.querySelectorAll('.component-navigation-drawer__nav-item');
  
  // 移除所有项目的选中状态
  navItems.forEach(item => {
    item.classList.remove('component-navigation-drawer__nav-item--selected');
    item.removeAttribute('data-selected');
    item.setAttribute('aria-selected', 'false');
  });
  
  // 设置点击项目为选中状态
  clickedItem.classList.add('component-navigation-drawer__nav-item--selected');
  clickedItem.setAttribute('data-selected', 'true');
  clickedItem.setAttribute('aria-selected', 'true');
}

/**
 * 设置导航项目的选中状态
 */
function setNavigationItemSelected(drawer, itemIndex) {
  const navItems = drawer.querySelectorAll('.component-navigation-drawer__nav-item');
  
  if (itemIndex >= 0 && itemIndex < navItems.length) {
    handleSelectionChange(drawer, navItems[itemIndex]);
  }
}

/**
 * 获取当前选中的导航项目
 */
function getSelectedNavigationItem(drawer) {
  const selectedItem = drawer.querySelector('.component-navigation-drawer__nav-item--selected');
  return selectedItem;
}

/**
 * 禁用导航项目
 */
function disableNavigationItem(drawer, itemIndex) {
  const navItems = drawer.querySelectorAll('.component-navigation-drawer__nav-item');
  
  if (itemIndex >= 0 && itemIndex < navItems.length) {
    const item = navItems[itemIndex];
    item.classList.add('component-navigation-drawer__nav-item--disabled');
    item.setAttribute('data-disabled', 'true');
    item.setAttribute('aria-disabled', 'true');
  }
}

/**
 * 启用导航项目
 */
function enableNavigationItem(drawer, itemIndex) {
  const navItems = drawer.querySelectorAll('.component-navigation-drawer__nav-item');
  
  if (itemIndex >= 0 && itemIndex < navItems.length) {
    const item = navItems[itemIndex];
    item.classList.remove('component-navigation-drawer__nav-item--disabled');
    item.removeAttribute('data-disabled');
    item.removeAttribute('aria-disabled');
  }
}

// 导出函数供外部使用
window.NavigationDrawerComponent = {
  init: initNavigationDrawers,
  setSelected: setNavigationItemSelected,
  getSelected: getSelectedNavigationItem,
  disable: disableNavigationItem,
  enable: enableNavigationItem
};

// 立即执行一次，以防DOMContentLoaded已经触发
if (document.readyState === 'loading') {
  // Document still loading, waiting for DOMContentLoaded
} else {
  initNavigationDrawers();
}

// 窗口大小改变时重新初始化
window.addEventListener('resize', function() {
  // 防抖处理
  clearTimeout(window.navigationDrawerResizeTimeout);
  window.navigationDrawerResizeTimeout = setTimeout(() => {
    initNavigationDrawers();
  }, 100);
}); 